var map = {
	"./de.json": [
		"../locale/res/wordlists/de.json",
		4
	],
	"./en.json": [
		"../locale/res/wordlists/en.json",
		5
	],
	"./es.json": [
		"../locale/res/wordlists/es.json",
		6
	],
	"./fr.json": [
		"../locale/res/wordlists/fr.json",
		7
	],
	"./pt.json": [
		"../locale/res/wordlists/pt.json",
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../locale/res/wordlists lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;